import { t } from "i18next";
import moment, { DurationInputArg2, Moment, unitOfTime } from "moment";

export const differenceInDays = (fromDate: string, toDate: string) => {
  const startDate = moment(fromDate);
  const endDate = moment(toDate);

  const daysDifference = endDate.diff(startDate, "days");
  const daysDifferenceWord = daysDifference === 1 ? t("day") : t("days");

  return daysDifference > 0 ? `${daysDifference} ${daysDifferenceWord}` : "-";
};

export const getStartOfDateByTimeUnit = (
  value: Date | null,
  unitOfTime: unitOfTime.StartOf
) => {
  return new Date(moment(value).startOf(unitOfTime).toISOString());
};

export const getEndOfDateByTimeUnit = (
  value: Date | null,
  unitOfTime: unitOfTime.StartOf
) => {
  return new Date(moment(value).endOf(unitOfTime).toISOString());
};

export const getDatesOfTimeUnit = (
  length: number,
  startDate: Moment,
  timeUnit: DurationInputArg2
) => {
  return Array.from({ length }, (_, index) =>
    startDate.clone().add(index, timeUnit).format("YYYY-MM-DD")
  );
};

export const getDatesBetweenTwoDates = (
  startDate: Date,
  endDate: Date
): string[] => {
  const dates: string[] = [];
  let currentDate = new Date(startDate);
  const endDateTime = endDate.getTime();

  while (currentDate.getTime() <= endDateTime) {
    dates.push(currentDate.toISOString().split("T")[0]);
    currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
  }

  return dates;
};

export const joinDateAndTime = (date: Date, time: string | null) => {
  const formattedDate =
    date && time
      ? moment(date).set({
          hour: parseInt(time.split(":")[0]),
          minute: parseInt(time.split(":")[1]),
          second: 0,
          millisecond: 0
        })
      : moment(date);

  return formattedDate.toISOString();
};
